// src/components/About/About.jsx
import React from 'react';
import './About.css'; // optional if you have styles

export default function About() {
  return (
    <section
  className="block-container"
  id="about"
  style={{
    color: '#f0f0f0',
    fontSize: '1.1rem',
    fontWeight: '500',
    textShadow: '1px 1px 3px rgba(0,0,0,0.6)',
    lineHeight: '1.6'
  }}
>

      <h2>About Me</h2>
      <p>
        First: That pic is about me about 50 years ago. I used it because I thought I looked something like 50 cent then, instead of how I look now which is something like twenty dollars and 50 cents.
      </p>
      <div>
        <img
          style={{
            width: '120px',
            borderRadius: '70px',
            boxShadow: '0 2px 14px #f05',
            float: 'right',
            marginLeft: '1.3em',
            marginBottom: '0.8em',
          }}
          src="./imageedit_2_4121293449.jpg"
          alt="Artist Photo"
        />
        <p>
          I’m <strong>Mardukson</strong> — a <em>targeted individual</em>, <strong>music producer, songwriter, novelist, and multimedia artist</strong>. My work spans sound, story, and visual art — all inspired by <strong>the Most High</strong>, <strong>Justice</strong>, and <strong>Nimrod — the true Christ</strong>. Everything I create is original and dedicated to all genuine targeted individuals.
        </p>
        <h4 style={{ color: '#000099' }}>My Creative Process</h4>
        <p>
          People often ask: <em>“Are your works A.I.?”</em><br />
          <strong>Short answer:</strong> No.<br />
          <strong>Long answer:</strong> I use A.I. the way any artist uses tools or collaborators. A songwriter may work with musicians and singers; a novelist may collaborate with editors. In the same spirit, I use A.I. to expand on my original ideas — to generate variations in different artistic styles or to explore alternative interpretations of my own work.
        </p>
        <p>
          For my <strong>artwork</strong>, A.I. helps me visualize my concepts in the style of various painters. If I were creating canvas pieces, I’d paint them myself — but for prints, A.I. allows me to produce professional results in minutes rather than weeks.
        </p>
        <p>
          When it comes to songs, most every word and lyric is mine. A.I. might occasionally suggest a clever line or verse I can use but A.I. don't write a better song than me, anymore than anybody else—speaking in general.
        </p>
        <p>
          I write full-length novels better than A.I. Believe me, I tried to get lazy, but in fiction writing, A.I. will take you to the North Pole before sticking to your plot. It can certainly add color and depth to scenes and scenery, but it don't get into the psychology of writing good fiction because it can't know your mind and what motivations you give your characters for their actions and what you want it all to lead to.
        </p>
        <p>
          Most “A.I.-generated” music sounds formulaic because it’s built from patterns — tone, tempo, and meter determined by machine logic. What sets my work apart is that <strong>the lyrics lead the backing tracks</strong>. The emotion, meaning, and rhythm of the words drive the entire composition. That’s the human element no algorithm can replace — the timeless truth that <em>real creativity always rises to the top.</em>
        </p>
        <h4 style={{ color: '#000066' }}>My Journey</h4>
        <p>
          I started writing songs when I was about 12 years old and sending them out to music publishers in Nashville when I was 14. Most songwriters are going to favor country music because it is a lyrics-driven genre more than a beat/instrumental one.
        </p>
        <p>
          I didn't know then that publishers got offended if you sent them songs without putting money into demo-ing them. I was sending out songs with no music at all—just my non-singing ass warbling a cappella. I thought they could look beyond the ear assaults and sign me for the lyrics. One time one of them, instead of just throwing the tape in the trash, took the time out to spit tobacco on the tape and spend money to mail it back to me. That was the last time I ever sent a song to a publisher and I've written hundreds of great songs since then that A.I. has yet to grace for me.
        </p>
        <p>
          I'm not a performer or singer and never wanted to be. This is why I have always written in all major genres with all types of performers/singers in mind.
        </p>
        <h4>Why I use A.I.</h4>
        <p>
          Can't play an instrument. Can't sing. I can produce and arrange though. For me, A.I. isn’t a replacement for creativity; it’s a tool that helps me <strong>bring my vision to life independently</strong>. As a targeted individual, I’ve learned that collaboration with others really isn't possible — nobody likes your ass, even from a distance and everybody you try to work with is going to take the slightest opportunity to ditch and rob you. Technology allows me to produce professional, uncompromised art by myself, on my own terms.
        </p>
        <p>
          A.I. doesn’t create my art — <strong>it helps me realize it.</strong>
        </p>
      </div>
    </section>
  );
}
